import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpBackend, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DownloadArchiveService {
  public isFormingArchive: Subject<boolean> = new Subject();

  private readonly http: HttpClient;

  constructor(private _backend: HttpBackend) {
    // Отключаем все добавленные интерсепторы
    this.http = new HttpClient(_backend);
  }

  public getUrlsForDownload(url: string): Observable<{ state: string }> {
    return this.http.get<{ state: string }>(url, { withCredentials: true });
  }
}
